import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import DialogTitle from 'components/atoms/DialogTitle/DialogTitle';
import LoadingSpinner from 'components/atoms/LoadingSpinner/LoadingSpinner';
import { ReactElement, ReactNode } from 'react';

type DialogComponentProps = MuiDialogProps & {
  title: string;
  titleIcon?: ReactElement;
  loading?: boolean;
  stretch?: boolean;
  onDialogClose: () => void;
  children: ReactNode;
};

const DialogComponent = ({
  title,
  titleIcon,
  loading,
  stretch,
  onDialogClose,
  children,
  ...muiDialogProps
}: DialogComponentProps): ReactElement => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const paperProps = {
    ...muiDialogProps?.PaperProps,
    sx: { ...(stretch ? { minHeight: '90vh' } : muiDialogProps?.PaperProps?.sx) },
  };

  return (
    <MuiDialog
      onClose={onDialogClose}
      fullWidth
      fullScreen={isFullScreen}
      BackdropProps={{ appear: false }}
      TransitionProps={{ appear: false }}
      {...muiDialogProps}
      sx={
        isFullScreen
          ? undefined
          : {
              ...(muiDialogProps || {}).sx,
              maxHeight: `calc(100% - ${theme.spacing(16)})`,
              marginTop: 8,
              marginBottom: 8,
            }
      }
      PaperProps={paperProps}
    >
      <DialogTitle title={title} titleIcon={titleIcon} onDialogClose={onDialogClose} />
      {loading ? (
        <DialogContent dividers sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <LoadingSpinner />
        </DialogContent>
      ) : (
        children
      )}
    </MuiDialog>
  );
};

export default DialogComponent;
